import { ColumnDef } from "@tanstack/react-table";
import { Checkbox } from "@/components/ui/checkbox";
import { LIST_SELECT_PREFIX } from "@/config/list";

type ColumnKey<T> = Extract<keyof T, string>;
type SelectMode = "multi" | "single";

export type SelectColumnProps<T> = Omit<ColumnDef<T>, "id" | "accessorKey"> & {
	id: ColumnKey<T>;
	mode: SelectMode;
};

type SelectColumnFn = <T>(props: SelectColumnProps<T>) => ColumnDef<T>;

export const SelectColumn: SelectColumnFn = ({ id, mode, ...rest }) => {
	return {
		id: `${LIST_SELECT_PREFIX}${id}`,
		header: ({ table }) =>
			mode === "multi" ? (
				<div className="flex items-center">
					<Checkbox
						checked={
							table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")
						}
						className="h-4 w-4 mb-0"
						onCheckedChange={value => table.toggleAllPageRowsSelected(!!value)}
						aria-label="Select all"
					/>
				</div>
			) : (
				<div></div>
			),

		cell: ({ row, table }) => {
			if (mode === "multi") {
				return (
					<div className="px-1 flex items-center">
						<Checkbox
							checked={row.getIsSelected()}
							onCheckedChange={value => row.toggleSelected(!!value)}
							aria-label="Select row"
							className="h-4 w-4"
						/>
					</div>
				);
			}

			const handleSelect = () => {
				table.resetRowSelection();
				row.toggleSelected(true);
			};

			return (
				<div className="px-1">
					<input
						type="radio"
						checked={row.getIsSelected()}
						onChange={handleSelect}
						className="h-4 w-4 accent-primary"
						aria-label="Select row"
					/>
				</div>
			);
		},
		enableSorting: false,
		enableHiding: false,
		...rest,
	};
};
